import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCx-bMMRkB_PsEJDKmFgKUKJ2InKy0tYQM",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "rail-res.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "rail-res",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "rail-res.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "652124361006",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:652124361006:web:ee2f2c1f087af0432e2abf",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-YW5K8LFF6G",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Google Auth Provider Configuration
export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('profile');
googleProvider.addScope('email');
googleProvider.setCustomParameters({
  'login_hint': 'user@example.com'
});

// Development: Connect to emulators
if (process.env.NODE_ENV === 'development' && !process.env.REACT_APP_DISABLE_EMULATOR) {
  try {
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectStorageEmulator(storage, 'localhost', 9199);
    connectFunctionsEmulator(functions, 'localhost', 5001);
  } catch (error) {
    // Emulator might already be connected, ignore error
    console.log('Emulator connection info:', error.message);
  }
}

export default app;
